(() => {
  const fillInquiryContext = (root = document) => {
    root.querySelectorAll('.inquiry-form').forEach((form) => {
      const params = new URLSearchParams(window.location.search);
      const fields = {
        product: params.get('product'),
        sku: params.get('sku'),
        source: params.get('source') || document.referrer || window.location.pathname
      };
      Object.entries(fields).forEach(([name, value]) => {
        const input = form.querySelector(`[data-context="${name}"]`);
        if (input && value) input.value = value;
      });
    });
  };

  const setupProductForm = (root = document) => {
    root.querySelectorAll('.product-form').forEach((form) => {
      const select = form.querySelector('[data-variant-select]');
      const idInput = form.querySelector('[name="id"]');
      const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
      const button = form.querySelector('[data-add-to-cart]');
      if (!select || !idInput) return;
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        idInput.value = option.value;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (button) {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
  };

  fillInquiryContext();
  setupProductForm();
  document.addEventListener('shopify:section:load', (event) => {
    fillInquiryContext(event.target);
    setupProductForm(event.target);
  });
})();
